/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Delete_Confirm_TitleInputs */

const en_story_bank_delete_confirm_title = /** @type {(inputs: Story_Bank_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this story?`)
};

const de_story_bank_delete_confirm_title = /** @type {(inputs: Story_Bank_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this story?`)
};

const fr_story_bank_delete_confirm_title = /** @type {(inputs: Story_Bank_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this story?`)
};

const es_story_bank_delete_confirm_title = /** @type {(inputs: Story_Bank_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this story?`)
};

const it_story_bank_delete_confirm_title = /** @type {(inputs: Story_Bank_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this story?`)
};

const nl_story_bank_delete_confirm_title = /** @type {(inputs: Story_Bank_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this story?`)
};

const pl_story_bank_delete_confirm_title = /** @type {(inputs: Story_Bank_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this story?`)
};

const fi_story_bank_delete_confirm_title = /** @type {(inputs: Story_Bank_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this story?`)
};

const da_story_bank_delete_confirm_title = /** @type {(inputs: Story_Bank_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this story?`)
};

const sv_story_bank_delete_confirm_title = /** @type {(inputs: Story_Bank_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this story?`)
};

/**
* | output |
* | --- |
* | "Delete this story?" |
*
* @param {Story_Bank_Delete_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_delete_confirm_title = /** @type {((inputs?: Story_Bank_Delete_Confirm_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Delete_Confirm_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_delete_confirm_title(inputs)
	if (locale === "fr") return fr_story_bank_delete_confirm_title(inputs)
	if (locale === "es") return es_story_bank_delete_confirm_title(inputs)
	if (locale === "it") return it_story_bank_delete_confirm_title(inputs)
	if (locale === "nl") return nl_story_bank_delete_confirm_title(inputs)
	if (locale === "pl") return pl_story_bank_delete_confirm_title(inputs)
	if (locale === "fi") return fi_story_bank_delete_confirm_title(inputs)
	if (locale === "da") return da_story_bank_delete_confirm_title(inputs)
	if (locale === "sv") return sv_story_bank_delete_confirm_title(inputs)
	return en_story_bank_delete_confirm_title(inputs)
});